import { Injectable, Provider } from "@angular/core";
import { Observable } from "rxjs";
import { AddressClient, AddressDto, AddressListGetQuery, AddressListGetQueryResult, AddressSetCommand, AddressDeleteCommand, AddressSetCommandResult, CountryListGetQuery, CountryListGetQueryResult } from "../../INTEGRA_Shop_Client";
import { IAddressApiService, IAddressApiServiceToken } from "./address-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class AddressApiService implements IAddressApiService {

  constructor(
    private addressClient: AddressClient,
  ) { }

  public countryListGet(filterDuplicatesByCountryCode?: boolean | undefined): Observable<CountryListGetQueryResult> {
    let query = new CountryListGetQuery();
    query.filterDuplicatesByCountryCode = filterDuplicatesByCountryCode;

    return this.addressClient.countryListGet(query);
  }

  public addressListGet(): Observable<AddressListGetQueryResult> {
    let query = new AddressListGetQuery();
    return this.addressClient.addressListGet(query);
  }

  public addressSet(address?: AddressDto | undefined): Observable<AddressSetCommandResult> {
    let command = new AddressSetCommand({
      address: address
    });
    return this.addressClient.addressSet(command);
  }

  public addressDelete(address?: AddressDto | undefined): Observable<boolean> {
    let command = new AddressDeleteCommand({
      address: address
    });
    return this.addressClient.addressDelete(command);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AddressApiServiceProvider: Provider[] = [
  { provide: AddressClient },
  { provide: IAddressApiServiceToken, useExisting: AddressApiService }
];
